"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PillList;
var _react = _interopRequireDefault(require("react"));
var _Pill = _interopRequireDefault(require("../Pill"));
require("./styles.scss");
function PillList(props) {
  const {
    data,
    onClick,
    onRemove,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pill-list"
  }, data.map((item, index) => /*#__PURE__*/_react.default.createElement(_Pill.default, {
    key: index,
    id: item.id,
    label: item.label,
    value: item.value,
    onClick: item.onClick || onClick,
    onRemove: item.onRemove || onRemove,
    className: item.className || className
  })));
}